import {CommonComponentModule} from './../../common-component/common-component.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from 'src/app/material/material';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomCommonModule} from 'src/app/common/custom.common.module';

export const componentList = [];

@NgModule({
  declarations: [componentList],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CommonComponentModule,
    CustomCommonModule
  ],
  entryComponents: [componentList]
})
export class EmailEntryModule { }
